module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAN0lEQVQ4T2NkoBAwUqifYdQABiqEwYwZMy4wMjLqkxkbFxgpMeD///8XR6ORGtFIZvTBtVEcCwCVNApDPc3sHwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/shopping_cart/minus.png
// module id = IM1b
// module chunks = 1